// extracted by css-extract-rspack-plugin
module.exports =  {"bar":"ProgressBar__bar--wL4FU","value":"ProgressBar__value--DYux4","progress":"ProgressBar__progress--HxWAy"};